<template>
  <div>
    <div v-if="campaigns">
      <BannerCampaig :banner="campaigns.image" :titulo="campaigns.title"></BannerCampaig>
      <div class="blog__topo ui-container">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="box">
                <div class="period">
                  Período de Validade:<br>
                  <span>{{campaigns.start_campaig}} a {{campaigns.end_campaig}}</span>
                </div>
                <div class="titulo padding-rigth-title">
                  {{campaigns.subtitle}}
                </div>
                <p v-html="campaigns.description"></p>
              </div>
            </div>
            <div class="col-12 mt-4" :class="{'col-lg-8 mt-lg-5' : campaigns.awards_description && campaigns.awards}">
              <div class="box regulation">
                <div class="titulo">
                  Regulamento
                </div>
                <p v-html="campaigns.regulation_description"></p>
                <div class="d-flex justify-content-center" v-if="campaigns.regulation_pdf">
                  <a :href="campaigns.regulation_pdf" target="_blank">
                    <button type="submit" class="ui-button">
                      Visualizar Regulamento
                    </button>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-12 mt-lg-5 mt-4" v-if="campaigns.awards_description && campaigns.awards">
              <div class="box award">
                <div class="titulo">
                  Premiação
                </div>
                <p v-html="campaigns.awards_description"></p>
                <span v-html="campaigns.awards"></span>
              </div>
            </div>
            <div id="form"  class="col-lg-8 col-12 mt-lg-5 mt-4">
              <div class="participar">
                <span>QUERO PARTICIPAR</span>
              </div>
              <div class="box">
                <p v-html="campaigns.participate_description"></p>
                <div class="titulo">
                  Seus Dados
                </div>
                <form @submit.prevent="submitForm">
                  <div class="inputs w-100">
                    <div class="row">
                      <div class="col-12">
                        <div class="group w-100">
                          <span class="highlight"></span>
                          <input type="text" maxlength="250" v-model="form.name" required>
                          <span class="bar"></span>
                          <label>Nome completo</label>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="group w-100">
                          <span class="highlight"></span>
                          <input type="email" maxlength="250" v-model="form.email" required>
                          <span class="bar"></span>
                          <label>E-mail</label>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="group w-100">
                          <span class="highlight"></span>
                          <the-mask required=""
                          type="text"
                          v-model="form.phone"
                          :mask="['(##) ####-####', '(##) #####-####']" />
                          <span class="bar"></span>
                          <label>Telefone</label>
                        </div>
                      </div>
                    </div>
                    <div class="titulo">
                      Dados da pessoa que você está indicando
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="group w-100">
                          <span class="highlight"></span>
                          <input type="text" maxlength="250" v-model="form.indication_name" required>
                          <span class="bar"></span>
                          <label>Nome completo</label>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="group w-100">
                          <span class="highlight"></span>
                          <input type="email" maxlength="250" v-model="form.indication_email" required>
                          <span class="bar"></span>
                          <label>E-mail</label>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="group w-100">
                          <span class="highlight"></span>
                          <the-mask required=""
                          type="text"
                          v-model="form.indication_phone"
                          :mask="['(##) ####-####', '(##) #####-####']" />
                          <span class="bar"></span>
                          <label>Telefone</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 d-flex justify-content-center termos p-0">
                      <input type="checkbox" id="termos" value="1" v-model="term" aria-label="Termos" required="required">
                      <label class="text-center" for="termos">Li e concordo com os termos do <span v-if="!campaigns.regulation_pdf">regulamento da campanha</span></label>
                      <a class="text-center" v-if="campaigns.regulation_pdf" :href="campaigns.regulation_pdf" target="_blank" rel="noopener noreferrer">regulamento da campanha</a>
                    </div>
                  </div>
                  <button type="submit" class="ui-button w-100 mt-2" :disabled="disabled">
                    {{submitButton}}
                  </button>
                </form>
              </div>
            </div>
            <div class="col-lg-4 col-12 mt-lg-5 mt-4" v-if="companyData">
              <div class="contato" v-if="contatoData">
                <div class="titulo_contato">
                  Entre em contato
                </div>
                <div class="telefone" v-if="contatoData.phone && contatoData.phone_formated">
                  <a :href="'tel:'+contatoData.phone" class="pop">
                    <i class="fa fa-phone"></i> {{contatoData.phone_formated}}
                  </a>
                </div>
                <div class="telefone" v-if="contatoData.cellphone && contatoData.cellphone_formated">
                  <a :href="'https://api.whatsapp.com/send?phone='+contatoData.cellphone" target="_blank" class="pop">
                    <i class="fa fa-whatsapp"></i> {{contatoData.cellphone_formated}}
                  </a>
                </div>
                <div class="email" v-if="contatoData.email">
                  <a :href="'mailto:'+contatoData.email" class="pop">
                    {{contatoData.email}}
                  </a>
                </div>
                <div class="titulo_redes">
                  Siga-nos
                </div>
                <div class="redes">
                  <a v-for="(item,index) in socialNetworks" :key="index" :href="item.link" target="_blank">
                    <i class="fa fa-linkedin pop" v-if="item.link && item.type == 'linkedin'" ></i>
                    <i class="fa fa-youtube pop" v-if="item.link && item.type == 'youtube'" ></i>
                    <i class="fa fa-facebook pop" v-if="item.link && item.type == 'facebook'" ></i>
                    <i class="fa fa-instagram pop" v-if="item.link && item.type == 'instagram'" ></i>
                    <i class="fa fa-twitter pop" v-if="item.link && item.type == 'twitter'" ></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!campaigns">
      <div class="blog__topo ui-container">
        <div class="container">
          <div class="row">
            <div class="col-12 mt-5">
              <div class="box mt-5">
                <div class="titulo text-center">
                  Ops! Essa campanha já acabou!
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import BannerCampaig from './BannerCampaig.vue'
import {TheMask} from 'vue-the-mask'
import swal from 'sweetalert2'

export default {
  data () {
    return {
      destiny: '',
      subject: '',
      disabled: false,
      submitButton: 'Enviar mensagem',
      form: {
        name: '',
        email: '',
        phone: '',
        indication_name: '',
        indication_email: '',
        indication_phone: ''
      },
      term: false,
      contatoData: {}
    }
  },
  components: {
    BannerCampaig,
    TheMask
  },
  computed: {
    ...mapGetters([
      'campaigns',
      'companyData',
      'socialNetworks',
      'contactSectors'
    ])
  },
  created () {
    this.$store.dispatch('loadCampaigns', this.$route.params.slug).then(response => {
      document.title = 'Comcasa | ' + response.data.title
    })
    this.$store.dispatch('listContactSectors')
      .then(() => {
        this.destiny = this.contactSectors[4].email
        this.subject = this.contactSectors[4].subject
      })
    this.$store.dispatch('listCompanyData')
      .then(() => {
        this.contatoData = this.companyData
        if (this.contatoData.cellphone) {
          let cellphoneP1 = this.contatoData.cellphone.slice(0, 2)
          let cellphoneP2 = this.contatoData.cellphone.slice(2, 6)
          if (this.contatoData.cellphone.length === 11) {
            cellphoneP2 = this.contatoData.cellphone.slice(2, 7)
          }
          let cellphoneP3 = this.contatoData.cellphone.slice(-4)

          this.contatoData.cellphone_formated = cellphoneP1 + '. ' + cellphoneP2 + '.' + cellphoneP3
        }

        if (this.contatoData.phone) {
          let phoneP1 = this.contatoData.phone.slice(0, 2)
          let phoneP2 = this.contatoData.phone.slice(2, 6)
          if (this.contatoData.phone.length === 11) {
            phoneP2 = this.contatoData.phone.slice(2, 7)
          }
          let phoneP3 = this.contatoData.phone.slice(-4)

          this.contatoData.phone_formated = phoneP1 + '. ' + phoneP2 + '.' + phoneP3
        }
      })
  },
  watch: {
    '$route' (to, from) {
      this.loadCampaigns()
    }
  },
  methods: {
    submitForm () {
      this.disabled = true
      this.submitButton = 'Enviando'
      let content = {
        'id': this.campaigns.id,
        'destiny': this.destiny,
        'originName': 'Website Comcasa',
        'title': this.subject,
        'name': this.form.name,
        'email': this.form.email,
        'phone': this.form.phone,
        'indication_name': this.form.indication_name,
        'indication_email': this.form.indication_email,
        'indication_phone': this.form.indication_phone,
        'message': `
          Uma pessoa entrou em contato pelo website da Comcasa:<br><br>
          Nome: ${this.form.name}<br>
          E-mail: ${this.form.email}<br>
          Telefone: ${this.form.phone}<br><br>
          Com a indicação de:<br><br>
          Nome: ${this.form.indication_name}<br>
          E-mail: ${this.form.indication_email}<br>
          Telefone: ${this.form.indication_phone}<br>
          Através da campanha: ${this.campaigns.title} - ${this.campaigns.subtitle}
        `
      }
      this.$store.dispatch('sendCampaig', {data: content})
        .then(() => {
          this.$store.dispatch('sendActiveCampaign', {data: this.form})
          swal(
            'Enviado :)',
            'E-mail enviado com sucesso.',
            'success'
          )
          this.form = {
            name: '',
            email: '',
            phone: '',
            indication_name: '',
            indication_email: '',
            indication_phone: ''
          }
          this.term = false
          this.submitButton = 'Enviar mensagem'
          this.disabled = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/scss/_variables.scss";
.participar{
  color: #131828;
  font-family: Montserrat,sans-serif;
  font-size: 30px;
  font-weight: 800;
  padding: 0 0 40px;
  position: relative;
  span{
    &:before{
      background: #131828;
      bottom: 20px;
      content: "";
      height: 8px;
      left: 0;
      position: absolute;
      width: 30%;
    }
  }
  @media (max-width: 991px) {
    font-size: 24px;
  }
}

.contato{
  .titulo_contato {
    color: $primary;
    font-size: 26px;
    font-weight: 900;
    margin: 50px 0;
    text-transform: uppercase;
    @media (max-width: 991px) {
      margin: 30px 0 20px;
    }
  }
  .titulo_redes {
    color: $primary;
    font-size: 26px;
    font-weight: 900;
    margin: 50px 0 20px;
    text-transform: uppercase;
    @media (max-width: 991px) {
      margin: 30px 0 20px;
    }
  }

  .redes{
    a{
      i{
        padding: 0 5px;
        font-size: 22px
      }
    }
  }
  .telefone {
    margin-bottom: 20px;
    a {
      color: $primary;
      font-size: 26px;
      font-weight: bold;
      transition: all 0.3s;
      &:hover {
        transition: all 0.3s;
        color: $green;
      }
    }
    @media (max-width: 991px) {
      margin-bottom: 10px;
    }
  }
  .email {
    margin-bottom: 50px;
    @media (max-width: 991px) {
      margin-bottom: 30px;
    }
    a {
      color: $tabs;
      font-size: 18px;
      font-style: italic;
      font-weight: 300;
      transition: all 0.3s;
      &:hover {
        transition: all 0.3s;
        color: $green;
      }
    }
  }
  @media (max-width: 767px) {
    text-align: center;
  }
}
.box {
  background: white;
  border-radius: 10px;
  box-shadow: 10px 0px 35px 0px rgba(0, 26, 66, 0.2);
  padding: 40px;
  font-family: 'Montserrat';
  color: $text;
  .termos{
    display: flex;
    justify-content: center;
    align-items: center;
    label{
      padding: 0 !important;
    }
    a{
      margin: 0 0 8px 8px;
      z-index: 999;
    }
    .termos_check{
      width: auto !important;
    }
    .termos_text{
      margin: 10px 0 10px 10px;
    }
    @media (max-width: 844px) {
      flex-direction: column
    }
  }
  .period{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 70px;
    top: 30px;
    span{
      color: #000;
      font-weight: bold;
    }
    @media (max-width: 991px) {
      justify-content: flex-start;
      right: auto;
    }
  }
  .padding-rigth-title{
    padding-right: 225px;
    @media (max-width: 991px) {
      padding-right: 0px;
      margin-top: 50px;
      margin-bottom: 30px;
    }
  }
  .titulo {
    color: $primary;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 40px;
    line-height: 28px;
    @media (max-width: 991px) {
      margin-bottom: 30px;
    }
    @media (max-width: 767px) {
      font-size: 20px;
      line-height: 24px;
    }
  }
  .group {
    position:relative;
    margin-bottom:30px;
  }
  .inputs{
    .termos {
      input{
        position: absolute;
        top: 3px;
        opacity: 0;
        z-index: 99;
        cursor: pointer;
      }
      label{
        position: relative;
        padding-left: 28px;
        cursor: pointer;
        line-height: 20px;
        display: inline-block;
        color: #8f8f8f;
        font-size: 15px;
        top:0px;
      }
      input:focus ~ label, input:valid ~ label {
        top:0px;
      }

      input[type="checkbox"] + label:before {
          border: 1px solid #5D5C5C;
          content: "\00a0";
          display: inline-block;
          font: 16px/1em sans-serif;
          height: 18px;
          margin: 0 .25em 0 0;
          padding:0;
          vertical-align: top;
          width: 18px;
          border-radius:4px;
      }
      input[type="checkbox"]:checked + label:before {
          background: #009337;
          color: #FFF;
          content: "\2713";
          text-align: center;
      }
    }
  }
  input, textarea {
    padding:10px 10px 10px 5px;
    display:block;
    width: 100%;
    border:none;
    border-bottom:1px solid $effect;
    color: $silver;
    font-size: 16px;
    font-style: italic;
    font-weight: 300;
  }
  input:focus {
    outline:none;
  }
  textarea:focus {
    outline:none;
  }
  label {
    color:$effect;
    font-size:16px;
    font-weight:300;
    font-style: italic;
    position:absolute;
    pointer-events:none;
    left:5px;
    top:10px;
    transition:0.2s ease all;
    -moz-transition:0.2s ease all;
    -webkit-transition:0.2s ease all;
  }
  input:focus ~ label, input:valid ~ label {
    top:-20px;
    font-size:14px;
    color:$primary;
  }
  textarea:focus ~ label, textarea:valid ~ label {
    top:-20px;
    font-size:14px;
    color:$primary;
  }
  .bar {
    position:relative;
    display:block;
    width: 100%;
  }
  .bar:before, .bar:after {
    content:'';
    height:2px;
    width:0;
    bottom:1px;
    position:absolute;
    background:$primary;
    transition:0.2s ease all;
    -moz-transition:0.2s ease all;
    -webkit-transition:0.2s ease all;
  }
  .bar:before {
    left:50%;
  }
  .bar:after {
    right:50%;
  }
  input:focus ~ .bar:before, input:focus ~ .bar:after {
    width:50%;
  }
  textarea:focus ~ .bar:before, textarea:focus ~ .bar:after {
    width:50%;
  }
  .highlight {
    position:absolute;
    height:60%;
    width:100px;
    top:25%;
    left:0;
    pointer-events:none;
    opacity:0.5;
  }
  input:focus ~ .highlight {
    -webkit-animation:inputHighlighter 0.3s ease;
    -moz-animation:inputHighlighter 0.3s ease;
    animation:inputHighlighter 0.3s ease;
  }
  textarea:focus ~ .highlight {
    -webkit-animation:inputHighlighter 0.3s ease;
    -moz-animation:inputHighlighter 0.3s ease;
    animation:inputHighlighter 0.3s ease;
  }
  @-webkit-keyframes inputHighlighter {
    from {
      background:$primary;
    }
    to {
      background:transparent;
      width:0;
    }
  }
  @-moz-keyframes inputHighlighter {
    from {
      background:$primary;
    }
    to {
      width:0;
      background:transparent;
    }
  }
  @keyframes inputHighlighter {
    from {
      background:$primary;
    }
    to {
    background:transparent;
      width:0;
    }
  }
  .select {
    position: relative;
    width: 100%;
    margin-bottom: 30px;
  }
  .select-text {
    position: relative;
    font-size: 16px;
    font-weight: 300;
    font-style: italic;
    background-color: transparent;
    width: 100%;
    padding: 10px 10px 10px 0;
    font-size: 18px;
    border-radius: 0;
    border: none;
    border-bottom: 1px solid $effect;
  }
  .select-text:focus {
    outline: none;
    border-bottom: 1px solid $effect;
  }
  .select .select-text {
    appearance: none;
  -webkit-appearance:none
  }
  .select:after {
    position: absolute;
    top: 18px;
    right: 10px;
    width: 0;
    height: 0;
    padding: 0;
    content: '';
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid $effect;
    pointer-events: none;
  }
  .select-label {
    color: $effect;
    font-size: 16px;
    font-weight: 300;
    font-style: italic;
    position: absolute;
    pointer-events: none;
    left: 0;
    top: 10px;
    transition: 0.2s ease all;
  }
  .select-text:focus ~ .select-label, .select-text:valid ~ .select-label {
    color: $primary;
    top: -20px;
    transition: 0.2s ease all;
  font-size: 14px;
  }
  .select-bar {
    position: relative;
    display: block;
    width: 100%;
  }
  .select-bar:before, .select-bar:after {
    content: '';
    height: 2px;
    width: 0;
    bottom: 1px;
    position: absolute;
    background: $primary;
    transition: 0.2s ease all;
  }
  .select-bar:before {
    left: 50%;
  }
  .select-bar:after {
    right: 50%;
  }
  .select-text:focus ~ .select-bar:before, .select-text:focus ~ .select-bar:after {
    width: 50%;
  }
  .select-highlight {
    position: absolute;
    height: 60%;
    width: 100px;
    top: 25%;
    left: 0;
    pointer-events: none;
    opacity: 0.5;
  }
  @media (max-width: 422px) {
    padding: 30px
  }
}
.regulation{
  &:before {
    background: url(../assets/img/menu-button.png);
    background-size: contain;
    content: '';
    position: absolute;
    right: 50px;
    top: 30px;
    height: 40px;
    width: 40px;
    z-index: 5;
  }
}
.award{
  &:before {
    background: url(../assets/img/award.png);
    background-size: contain;
    content: '';
    right: 50px;
    position: absolute;
    top: 30px;
    transition: all 0.3s;
    height: 40px;
    width: 40px;
    z-index: 5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Campaig.vue